import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { ActiveStudentsByClassItemDTO } from "../api/client";

type ActiveStudentsByClassReportTableProps = {
  isLoading: boolean;
  data: ActiveStudentsByClassItemDTO[];
};

export function ActiveStudentsByClassReportTable({
  isLoading,
  data,
}: ActiveStudentsByClassReportTableProps) {
  const totalInTable = data.reduce(
    (sum, row) => sum + row.activeStudentCount,
    0,
  );

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[220px]">ປະເພດຄລາດສ໌</TableHead>
            <TableHead className="w-[160px]">ລະດັບ</TableHead>
            <TableHead className="w-[140px] text-right">
              ນັກຮຽນ Active
            </TableHead>
            <TableHead className="w-[100px] text-right">% ສັດສ່ວນ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={4}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={4}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນ
              </TableCell>
            </TableRow>
          ) : (
            <>
              {data.map((row) => {
                const share =
                  totalInTable > 0
                    ? ((row.activeStudentCount / totalInTable) * 100).toFixed(1)
                    : "0.0";
                return (
                  <TableRow
                    key={`${row.classTypeId}:${row.levelId}`}
                    className={
                      row.activeStudentCount === 0 ? "text-muted-foreground" : ""
                    }
                  >
                    <TableCell className="font-medium">
                      {row.classTypeName}
                    </TableCell>
                    <TableCell>{row.levelName}</TableCell>
                    <TableCell className="text-right font-semibold tabular-nums">
                      {row.activeStudentCount.toLocaleString()}
                    </TableCell>
                    <TableCell className="text-right text-muted-foreground tabular-nums">
                      {row.activeStudentCount > 0 ? `${share}%` : "—"}
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow className="bg-muted/40 font-medium">
                <TableCell colSpan={2}>ລວມ (ຕາມຕາຕະລາງ)</TableCell>
                <TableCell className="text-right tabular-nums">
                  {totalInTable.toLocaleString()}
                </TableCell>
                <TableCell />
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
